import React from 'react';
import './PipelineStatusCard.css';
import VybogTALLoaderAnimation from '../../../Common/Dynamic-Animations/DynamicAnimations';
const PipelineStatusCard = ({ data = [], containerRef, isLoadingMore = false }) => {
  const rows = Array.isArray(data) ? data : [];
  const getBarValue = (item) => Number(item.barValue ?? item.count) || 0;
  const maxValue = Math.max(...rows.map(getBarValue), 0);

  return (
    <div ref={containerRef}  className={`pipeline-status-container`}>
      {rows.map((item, index) => (
        <div key={item.id || index} className="pipeline-status-row">
          <div className={`pipeline-status-label`}>
            {item.stage}
          </div>
          <div className={`pipeline-status-bar-container`}>
            <div 
              className="pipeline-status-bar"
              style={{ 
                width: maxValue
                  ? `${(getBarValue(item) / maxValue) * 100}%`
                  : "0%",
                backgroundColor: item.color,
              }}
            />
          </div>
          <div className={`pipeline-status-count`}>
            {item.countLabel || item.count}
          </div>
        </div>
      ))}
      {isLoadingMore && (
        <VybogTALLoaderAnimation />
      )}
    </div>
  );
};
export default PipelineStatusCard;
